import { Box, Button, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { documentPage } from "../../tripDetails/style";
import { ChevronLeftRounded } from "@mui/icons-material";

const TripDocumentsHeader: React.FC<{ onGoBack: () => void; tripId?: string; isMobile:boolean }> = ({ onGoBack, tripId, isMobile }) => {
    const { t } = useTranslation();
    return (
      <>
       {isMobile ?<IconButton sx={{padding:0,margin:0, color:"#CF0A2C"}}  onClick={onGoBack}><ChevronLeftRounded sx={{ marginLeft:'-10px'}} fontSize="large"/></IconButton> :  <Button
          variant="contained"
          sx={{ marginBottom: "24px", fontWeight: "bold" }}
          onClick={onGoBack}
        >
          {t("screens.trips.tripDocuments.back")}
        </Button>}
        <Typography sx={documentPage.titlePage}>{t('screens.trips.tripDocuments.documents')}</Typography>
        <Box sx={documentPage.box1}>
          <Typography sx={documentPage.subtitle}>{t('screens.trips.tripDocumentPage.trip')}:</Typography>
          <Typography sx={documentPage.value}>{tripId}</Typography>
        </Box>
      </>
    );
  };
export default TripDocumentsHeader;  